<div class="inner-page-bg-right">
  <header data-aos="zoom-in" class="aos-init aos-animate">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'"> <img src="./assets/images/logo-inner.png" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="banner-left-text mb-4">
            <p>Hello <b>{{storeModel?.name}},</b></p>
            <p>Exciting plans! To boost sales!! Offer Unique experience to shoppers!</p>
            <p><b>{{businessModel?.company}}</b> is inviting you to participate in this exciting journey.</p>

            <br>
            <p><b>What’s in it for you?</b></p>

            <ul>
              <li><b>Simple Redemption:</b> Our process is straightforward for both you and your shoppers</li>
              <li><b>Effortless Tracking:</b> Keep tabs on redemptions and settlements with ease.</li>
              <li><b>Offer unique shopper experience</b></li>
              <li><b>No Software Hassles:</b> There’s absolutely no software to download.</li>
              <li><b>Opportunity to Run Your Own Promotions</b></li>
            </ul>

            <h2>Ready to Boost Your Sales?</h2>

            <p>Click the ‘Accept’ button below to confirm your participation and start attracting more customers to your store today!</p>
            <button type="submit" mat-raised-button (click)="onClickConfirm()" color="primary">Accept</button>
            <br>
            <br>
            <p>Should you have any inquiries or require assistance related to the campaign, please do not hesitate to reach out to your account representative at <b>{{businessModel?.company}}</b>.</p>
            <br>
            <p>Happy selling!</p>
            <p>Best Regards,</p>
            <p>The Scanfluence Team</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-admin-footer></app-admin-footer>